import type {
  CoachingQuotaLedgerReason,
  CoachingSessionType,
} from '@efdigital/ll-addon-data';

export const QUOTA_LEDGER_REASONS: Record<CoachingQuotaLedgerReason, string> = {
  session_book: 'Session booked',
  session_cancel_early: 'Session canceled early',
  session_cancel_late: 'Session canceled late',
  session_attended: 'Session attended',
  session_overrun: 'Session overrun',
  session_no_show_coach: 'No show by coach',
  session_no_show_both: 'No show by both',
  session_void: 'Session void',
  session_reschedule: 'Session rescheduled',
  admin_grant: 'Admin granted',
  admin_cancel: 'Admin canceled',
  booking_unconfirmed: 'Booking expired unconfirmed',
};

export const SESSION_TYPE_LABELS: Record<CoachingSessionType, string> = {
  chemistry: 'Chemistry',
  coaching: 'Coaching',
};

export function formatQuotaLedgerReason(reason: CoachingQuotaLedgerReason) {
  return QUOTA_LEDGER_REASONS[reason];
}

export function formatSessionType(sessionType: CoachingSessionType) {
  return SESSION_TYPE_LABELS[sessionType];
}
